import { Link } from "react-router-dom";
import { Image, UL } from "../../../AbstractElements";
import { dynamicImage } from "../../../Service/DynamicImage";
import { ArrowLeft, ChevronLeft, Grid } from "react-feather";
import { useAppSelector } from "../../../Redux-Toolkit/Hooks";
import SidebarMain from "./SidebarMain";
import { Href } from "../../../Constant";

const VerticalSidebar = () => {
  const { toogleSidebar } = useAppSelector((state) => state.layout);
  return (
    <div className={`sidebar-wrapper ${toogleSidebar ? "close_icon" : ""}`} sidebar-layout="stroke-svg">
      <div>
        <div className="logo-wrapper">
          <Link to={Href}>
            <Image className="for-light" src={dynamicImage("logo/logo.png")} alt="" />
            <Image className="for-dark" src={dynamicImage("logo/logo_dark.png")} alt="" />
          </Link>
          <div className="back-btn">
            <ChevronLeft />
          </div>
          <div className="toggle-sidebar">
            <Grid className="status_toggle middle sidebar-toggle" />
          </div>
        </div>
        <nav className="sidebar-main">
          <div className="left-arrow disabled" id="left-arrow">
            <ArrowLeft />
          </div>
          <div id="sidebar-menu">
            <UL className="sidebar-links simple-list" id="simple-bar">
              <SidebarMain />
            </UL>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default VerticalSidebar;
